import React, { useEffect, useRef, useState } from "react";
import { Modal } from "antd";
import { ChevronLeft, Close } from "@mui/icons-material";
import { ListItemsSkeleton } from "../../../../../components/page-skeleton";
import { toast } from "react-toastify";
import moment from "moment";

const TaskHistory = ({ preview, previewHandler, data }) => {
  // STATES
  const [isLoading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);
  const [selectedItem, setselectedItem] = useState(null);

  // CONST VALS
  const { http } = global.services;

  // HELPERS
  const getHistoryHelper = () => {
    setLoading(true);
    http
      .get(`company-task-history/${data.id}`)
      .finally(() => setLoading(false))
      .then((res) => {
        setHistory(res.data);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  };

  // HANDLERS
  const selectItem = (item) => {
    if (selectedItem?.id === item?.id) return setselectedItem(null);
    setselectedItem(item);
  };

  // HOOKS
  useEffect(() => {
    if (preview && data) getHistoryHelper();
  }, [preview, data]);

  return (
    <Modal
      visible={preview}
      centered
      className="task-history-modal"
      footer={null}
      onCancel={previewHandler}
      closable={false}
      width={800}
    >
      <button className="close-btn" onClick={previewHandler}>
        <Close />
      </button>
      <h2>Task History</h2>
      {isLoading ? (
        <ListItemsSkeleton rows={6} />
      ) : (
        <div className="task-history">
          {history.map((item, index) => {
            const collapsable = item?.old_value;
            return (
              <div
                key={index}
                className={`task-history-item ${
                  selectedItem?.id === item?.id ? "selected" : ""
                } ${collapsable ? "collapsable" : ""}`}
              >
                <div
                  className="header"
                  onClick={() => collapsable && selectItem(item)}
                >
                  <h2>{item.content}</h2>
                  {collapsable && (
                    <button>
                      <ChevronLeft />
                    </button>
                  )}
                </div>
                <div className={`content ${item.new_value ? "flexed" : ""}`}>
                  <span className="val-box">{item.old_value}</span>
                  {item.new_value && (
                    <>
                      <span className="arrow">→</span>
                      <span className="val-box">{item.new_value}</span>
                    </>
                  )}
                  <p>
                    Created at:{" "}
                    {moment(item.created).format("MMMM Do YYYY, h:mm:ss a")}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Modal>
  );
};

export default TaskHistory;
